import React, { useState } from 'react';
import cx from 'classnames';

const ROLE_BUTTONS = [
  {
    id: 1,
    btnContent: <>Talent acquisition</>,
  },
  {
    id: 2,
    btnContent: <>Human resources</>,
  },
  {
    id: 3,
    btnContent: <>Vendor management</>,
  },
];

export default function CurrentRoleSection() {
  const [activeButton, setActiveButton] = useState<number>();

  return (
    <section className="role-section">
      <div className="sub-title">
        <div className="sub-title-holder">
          Which of the following best describes your current role?
        </div>
      </div>
      <div className="container">
        <div className="btn-row">
          {ROLE_BUTTONS.map(({ id, btnContent }) => (
            <div className="btn-col with-circle" key={id}>
              <button
                disabled={!!activeButton}
                onClick={() => setActiveButton(id)}
                className={cx('btn size-lg', {
                  'primary-btn': activeButton !== id,
                  'outlined-btn': activeButton === id,
                })}
              >
                {activeButton === id ? (
                  <span className="icon icon-like" />
                ) : (
                  <span>{btnContent}</span>
                )}
              </button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
